<template>
  <div id="app">
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {}
  }
}
</script>

<style>
#app {
  /* background: #000; */
  overflow: hidden;
}
</style>
